import { ActionType, ComponentType, logEvent } from '@cbhq/client-analytics';

import { AnalyticEvent } from ':fat/analytics/events';
import { getDeviceId } from ':fat/init/identify';

export const context = 'commerce_funds_access_tool';

const baseGenericEventData = {
  componentType: ComponentType.page,
  action: ActionType.change,
  context,
};

const baseErrorEventData = {
  componentType: ComponentType.content_script,
  action: ActionType.measurement,
  context,
};

export function logGenericEvent(
  event: AnalyticEvent,
  additionalProperties?: Record<string, unknown>,
): void {
  logEvent(event, {
    ...baseGenericEventData,
    ...additionalProperties,
  });
}

export function logRender(event: AnalyticEvent): void {
  logGenericEvent(event, { action: ActionType.render });
}

export function logError(
  event: AnalyticEvent,
  additionalProperties?: Record<string, unknown>,
): void {
  logEvent(event, {
    deviceId: getDeviceId(),
    ...baseErrorEventData,
    ...additionalProperties,
  });
}
